import { render, staticRenderFns } from "./GuestDetailsIcon.vue?vue&type=template&id=6834a398"
import script from "./GuestDetailsIcon.vue?vue&type=script&lang=js"
export * from "./GuestDetailsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports